const ALPINA_FAMILY = "GT Alpina Condensed Thin Italic";

const alpinaWoff2 = require("@assets/fonts/GT-Alpina-Condensed-Thin-Italic.woff2");
const alpinaWoff = require("@assets/fonts/GT-Alpina-Condensed-Thin-Italic.woff");

export const CURATOR_FONT = `"${ALPINA_FAMILY}", Georgia, serif`;

let fontsLoaded = false;
let fontsLoading: Promise<void> | null = null;

export async function ensureStoryFontsLoaded(): Promise<void> {
  if (fontsLoaded) {
    return;
  }

  if (fontsLoading) {
    return fontsLoading;
  }

  fontsLoading = (async () => {
    if (!document.fonts) {
      fontsLoaded = true;
      return;
    }

    const font = new FontFace(
      ALPINA_FAMILY,
      `url(${alpinaWoff2}) format("woff2"), url(${alpinaWoff}) format("woff")`
    );

    await font.load();
    document.fonts.add(font);
    await document.fonts.load(`normal 100 16px "${ALPINA_FAMILY}"`);
    fontsLoaded = true;
  })();

  return fontsLoading;
}
